var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClusterColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_890_44326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4.33333C12.8933 4.33333 12 5.22667 12 6.33333C12 6.38 12 6.42667 12.0067 6.47333L10.6533 6.92667C10.2267 6.12 9.44 5.53333 8.50667 5.38V3.94C9.36 3.71333 10 2.93333 10 2C10 0.893333 9.10667 0 8 0C6.89333 0 6 0.893333 6 2C6 2.93333 6.64 3.71333 7.5 3.94V5.38C6.56667 5.53333 5.78 6.12 5.35333 6.92667L3.99333 6.47333C4 6.42667 4 6.38 4 6.33333C4 5.22667 3.10667 4.33333 2 4.33333C0.893333 4.33333 0 5.22667 0 6.33333C0 7.44 0.893333 8.33333 2 8.33333C2.70667 8.33333 3.32 7.96667 3.68 7.42L5.03333 7.87333C4.9 8.73333 5.14667 9.64667 5.76 10.3333L4.82 11.5133C4.56667 11.3933 4.29333 11.3333 4 11.3333C2.89333 11.3333 2 12.2267 2 13.3333C2 14.44 2.89333 15.3333 4 15.3333C5.10667 15.3333 6 14.44 6 13.3333C6 12.88 5.85333 12.4667 5.6 12.1333L6.54 10.9533C7.44667 11.46 8.55333 11.4533 9.45333 10.9533L10.3933 12.1333C10.1467 12.4667 10 12.88 10 13.3333C10 14.44 10.8933 15.3333 12 15.3333C13.1067 15.3333 14 14.44 14 13.3333C14 12.2267 13.1067 11.3333 12 11.3333C11.7067 11.3333 11.4333 11.3933 11.18 11.5067L10.24 10.3267C10.86 9.63333 11.1 8.72667 10.9667 7.86667L12.32 7.41333C12.6733 7.96 13.2933 8.32667 14 8.32667C15.1067 8.32667 16 7.43333 16 6.32667C16 5.22 15.1067 4.33333 14 4.33333ZM2 7C1.63333 7 1.33333 6.7 1.33333 6.33333C1.33333 5.96667 1.63333 5.66667 2 5.66667C2.36667 5.66667 2.66667 5.96667 2.66667 6.33333C2.66667 6.7 2.36667 7 2 7ZM4 14C3.63333 14 3.33333 13.7 3.33333 13.3333C3.33333 12.9667 3.63333 12.6667 4 12.6667C4.36667 12.6667 4.66667 12.9667 4.66667 13.3333C4.66667 13.7 4.36667 14 4 14ZM7.33333 2C7.33333 1.63333 7.63333 1.33333 8 1.33333C8.36667 1.33333 8.66667 1.63333 8.66667 2C8.66667 2.36667 8.36667 2.66667 8 2.66667C7.63333 2.66667 7.33333 2.36667 7.33333 2ZM8 10C7.08 10 6.33333 9.25333 6.33333 8.33333C6.33333 7.41333 7.08 6.66667 8 6.66667C8.92 6.66667 9.66667 7.41333 9.66667 8.33333C9.66667 9.25333 8.92 10 8 10ZM12 12.6667C12.3667 12.6667 12.6667 12.9667 12.6667 13.3333C12.6667 13.7 12.3667 14 12 14C11.6333 14 11.3333 13.7 11.3333 13.3333C11.3333 12.9667 11.6333 12.6667 12 12.6667ZM14 7C13.6333 7 13.3333 6.7 13.3333 6.33333C13.3333 5.96667 13.6333 5.66667 14 5.66667C14.3667 5.66667 14.6667 5.96667 14.6667 6.33333C14.6667 6.7 14.3667 7 14 7Z",
    fill: "url(#paint0_linear_890_44326)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_890_44326",
    x1: 15,
    y1: 1,
    x2: -7.49377e-7,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121846,
    stopColor: "#5CB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369283,
    stopColor: "#C90E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613704,
    stopColor: "#FFB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882982,
    stopColor: "#9339DB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_890_44326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClusterColor);
export default __webpack_public_path__ + "static/media/ico-cluster-color.6ef81724946ccb17a9501567e7cac13d.svg";
export { ForwardRef as ReactComponent };